import { useEffect, useRef } from "react";

import { trackPromoImpression } from "./promoImpression";

export function usePromoImpressionRef(promoId, source = "web") {
  const ref = useRef(null);

  useEffect(() => {
    if (!promoId || !ref.current) return;

    if (typeof IntersectionObserver === "undefined") {
      trackPromoImpression(promoId, source);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          trackPromoImpression(promoId, source);
          observer.disconnect();
        });
      },
      { threshold: 0.5 }
    );

    observer.observe(ref.current);

    return () => observer.disconnect();
  }, [promoId, source]);

  return ref;
}
